var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SvgDefs'),(_vm.siteNav)?_c('SiteNav'):_vm._e(),(!_vm.siteNav)?_c('SiteNavHamburger',{attrs:{"isHome":_vm.isHome}}):_vm._e(),_c('transition',{attrs:{"name":"vPage","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }